import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { AuthService } from '@elight/client/shared/utility/auth';

@Directive({
    selector: '[elightHasAccess]',
})
export class HasAccessDirective {
    private hasView = false;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private authService: AuthService
    ) {}

    /**
     * @param selector: String formatted as `page.field.rule` e.g. `project.name.hidden`
     */
    @Input() set elightHasAccess(selector: string) {
        const exp = /\w+\.{1}\w+\.{1}\w+/g;
        if (!selector || !selector.match(exp)) {
            this.clearElement();
            return;
        }

        const condition = this.authService.hasAccessToField(selector);

        if (condition && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (!condition && this.hasView) {
            this.clearElement();
        }
    }

    private clearElement() {
        this.viewContainer.clear();
        this.hasView = false;
    }
}
